"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var legacy_1 = require("satcheljs/lib/legacy");
var store_1 = require("../store/store");
var setMailboxJunkEmailConfiguration_1 = require("../services/setMailboxJunkEmailConfiguration");
exports.default = legacy_1.action('saveMailboxJunkMailConfiguration')(function saveMailboxJunkMailConfiguration(mailboxJunkEmailConfiguration) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    store_1.default.mailboxJunkEmailConfiguration = mailboxJunkEmailConfiguration;
                    return [4 /*yield*/, setMailboxJunkEmailConfiguration_1.default(mailboxJunkEmailConfiguration)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=saveMailboxJunkEmailConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-junkmail-configuration/lib/actions/saveMailboxJunkEmailConfiguration.js
// module id = 5018
// module chunks = 2